import { Facebook, Instagram, MessageCircle, Music2, Youtube } from "lucide-react";

export const NETWORKS = [
  { id: "whatsapp", label: "WhatsApp", Icon: MessageCircle, color: "#25D366", text: "#0A1230", mode: "link", hint: "Se abre WhatsApp con el texto y tu enlace. En el celular también se adjunta el archivo." },
  { id: "facebook", label: "Facebook", Icon: Facebook, color: "#1877F2", text: "#fff", mode: "link", hint: "Se abre Facebook con tu enlace listo para publicar; el texto queda copiado para pegarlo." },
  { id: "instagram", label: "Instagram", Icon: Instagram, color: "#E1306C", text: "#fff", mode: "file", hint: "Descargamos el archivo y copiamos el texto; pégalo al crear tu publicación o historia." },
  { id: "tiktok", label: "TikTok", Icon: Music2, color: "#010101", text: "#fff", mode: "file", hint: "Descargamos el video y copiamos el texto; pégalo al subir tu TikTok." },
  { id: "youtube", label: "YouTube", Icon: Youtube, color: "#FF0000", text: "#fff", mode: "file", hint: "Descargamos el video y copiamos la descripción; súbelo desde YouTube Studio." },
];

export const absolute = (url) => (url?.startsWith("/") ? `${window.location.origin}${url}` : url);
export const shareLink = (shareBase, slug, distId, network) => `${shareBase}/${slug}?ref=${distId}&n=${network}`;
export const buildCaption = (material, network, link) => `${(material.captions || {})[network] || material.title}\n${link}`;

const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const copy = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};

const download = (url, name) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.target = "_blank";
  a.rel = "noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

/** Comparte con un toque. Devuelve {method, copied} para mostrar la instrucción correcta al distribuidor. */
export async function shareTo(network, material, caption, link) {
  const url = absolute(material.url);
  const copied = await copy(caption);
  if (isMobile() && navigator.share) {
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const file = new File([blob], url.split("/").pop() || "material", { type: blob.type });
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], text: caption, title: material.title });
        return { method: "native", copied };
      }
    } catch (e) {
      if (e?.name === "AbortError") return { method: "cancelled", copied };
    }
  }
  if (network === "whatsapp") {
    window.open(`https://wa.me/?text=${encodeURIComponent(caption)}`, "_blank", "noopener");
    return { method: "whatsapp", copied };
  }
  if (network === "facebook") {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}&quote=${encodeURIComponent(caption)}`, "_blank", "noopener,width=640,height=560");
    return { method: "facebook", copied };
  }
  download(url, `${material.slug}.${url.split(".").pop()}`);
  const open = { instagram: "https://www.instagram.com/", tiktok: "https://www.tiktok.com/upload", youtube: "https://studio.youtube.com/" }[network];
  if (open) setTimeout(() => window.open(open, "_blank", "noopener"), 600);
  return { method: "download", copied };
}
